/* aerobis: AI disclosure badge (EU AI Act Art. 50)
   Adds an "Edited with AI" badge to any <img> whose ALT text carries the marker
   "(AI)" / "(KI)" / "(IA)" (the marker gets translated together with the ALT text).
   Scope: main product gallery (.product-gallery__media), article hero (.article-banner__image),
   rich text / blog (.prose), and the PhotoSwipe fullscreen zoom. Thumbnails / collection cards stay out.
   Localized for all published shop languages (fallback: English). */
(function () {
  var LABELS = {
    de: 'Mit AI bearbeitet',
    da: 'Redigeret med AI',
    es: 'Editado con IA',
    fr: 'Modifié avec l’IA',
    it: 'Modificato con IA',
    ja: 'AIで編集済み',
    nb: 'Redigert med AI',
    nl: 'Bewerkt met AI',
    pl: 'Edytowane z użyciem AI',
    pt: 'Editado com IA',
    sv: 'Redigerad med AI',
    zh: '由 AI 修改',
    en: 'Edited with AI'
  };

  var MARKER_RE = /\((?:ai|ki|ia)\)/i;
  var SCOPE = '.product-gallery__media img, .prose img, .article-banner__image img';

  var ICON = window.aerobisAiIcon || '';
  var FALLBACK_ICON = 'data:image/svg+xml;utf8,' + encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><circle cx="12" cy="12" r="11" fill="#1d1d1b"/><text x="12" y="16" text-anchor="middle" font-family="Arial,Helvetica,sans-serif" font-size="10" font-weight="700" fill="#fff">AI</text></svg>'
  );

  function currentLabel() {
    var l = (window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'en';
    l = l.toLowerCase().slice(0, 2);
    return LABELS[l] || LABELS.en;
  }

  function buildBadge(text) {
    var badge = document.createElement('span');
    badge.className = 'aerobis-ai-badge';
    badge.setAttribute('role', 'img');
    badge.setAttribute('aria-label', text);
    var icon = document.createElement('img');
    icon.className = 'aerobis-ai-badge__icon';
    icon.alt = '';
    icon.src = ICON || FALLBACK_ICON;
    icon.onerror = function () { this.onerror = null; this.src = FALLBACK_ICON; };
    var label = document.createElement('span');
    label.className = 'aerobis-ai-badge__text';
    label.textContent = text;
    badge.appendChild(icon);
    badge.appendChild(label);
    return badge;
  }

  function decorate(img) {
    if (!img || img.getAttribute('data-aerobis-ai') === '1') return;
    if (!MARKER_RE.test(img.getAttribute('alt') || '')) return;
    if (!img.matches(SCOPE)) return;
    img.setAttribute('data-aerobis-ai', '1');

    var badge = buildBadge(currentLabel());

    if (img.closest('.prose')) {
      var host = img.parentNode;
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      host.appendChild(badge);
      badge.style.bottom = 'auto';
      badge.style.right = 'auto';
      var place = function () {
        if (!img.offsetWidth && !img.offsetHeight) return;
        badge.style.left = (img.offsetLeft + img.offsetWidth - badge.offsetWidth - 8) + 'px';
        badge.style.top = (img.offsetTop + img.offsetHeight - badge.offsetHeight - 8) + 'px';
      };
      if (img.complete) place();
      img.addEventListener('load', place);
      window.addEventListener('resize', place);
      setTimeout(place, 300);
    } else {
      img.parentNode.insertBefore(badge, img.nextSibling);
    }
  }

  function scan(root) {
    var imgs = (root || document).querySelectorAll(SCOPE);
    for (var i = 0; i < imgs.length; i++) decorate(imgs[i]);
  }

  function currentPswpImg(pswp) {
    var imgs = pswp.querySelectorAll('.pswp__img');
    var cx = window.innerWidth / 2, best = null, bestD = Infinity;
    for (var i = 0; i < imgs.length; i++) {
      var r = imgs[i].getBoundingClientRect();
      if (!r.width) continue;
      var d = Math.abs((r.left + r.width / 2) - cx);
      if (d < bestD) { bestD = d; best = imgs[i]; }
    }
    return best;
  }

  function syncPswp() {
    var pswp = document.querySelector('.pswp.pswp--open');
    var badge = document.querySelector('.aerobis-ai-badge--pswp');
    if (!pswp) { if (badge) badge.remove(); return; }
    var img = currentPswpImg(pswp);
    var marked = img && MARKER_RE.test(img.getAttribute('alt') || '');
    if (!marked) { if (badge) badge.remove(); return; }
    var text = currentLabel();
    if (!badge) {
      badge = buildBadge(text);
      badge.className += ' aerobis-ai-badge--pswp';
      pswp.appendChild(badge);
    } else {
      badge.querySelector('.aerobis-ai-badge__text').textContent = text;
      badge.setAttribute('aria-label', text);
    }
    var r = img.getBoundingClientRect();
    var bw = badge.offsetWidth || 90, bh = badge.offsetHeight || 21;
    var left = Math.min(r.right, window.innerWidth) - bw - 12;
    var top = Math.min(r.bottom, window.innerHeight) - bh - 12;
    badge.style.left = Math.max(8, left) + 'px';
    badge.style.top = Math.max(8, top) + 'px';
  }

  function scheduleSync() {
    var delays = [0, 150, 400, 800, 1500];
    for (var i = 0; i < delays.length; i++) setTimeout(syncPswp, delays[i]);
  }

  function init() {
    scan(document);
    scheduleSync();
    if (window.MutationObserver) {
      var mo = new MutationObserver(function (muts) {
        var touchPswp = false;
        for (var i = 0; i < muts.length; i++) {
          var m = muts[i];
          if (m.type === 'attributes' && m.target.tagName === 'IMG') {
            decorate(m.target);
            if (('' + m.target.className).indexOf('pswp') > -1) touchPswp = true;
          }
          var lists = [m.addedNodes, m.removedNodes], k;
          for (k = 0; k < 2; k++) {
            for (var j = 0; j < lists[k].length; j++) {
              var n = lists[k][j];
              if (n.nodeType !== 1) continue;
              if (('' + n.className).indexOf('pswp') > -1) touchPswp = true;
              if (n.querySelector && n.querySelector('.pswp')) touchPswp = true;
              if (k === 0) { if (n.tagName === 'IMG') decorate(n); else scan(n); }
            }
          }
        }
        if (touchPswp) scheduleSync();
      });
      mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['alt', 'src'] });
    }
    document.addEventListener('pointerup', scheduleSync, true);
    document.addEventListener('keyup', scheduleSync, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
